import { getDeviceStrokeColor } from "../../../helper/service";

interface Props {
  getnumber?: any;
  bgcolor?: any;
  fontColor?: any;
  checked?: boolean;
  themeMode?: String;
  size?: number;
  roomWrostColor?: any;
  forType?: any;
  id?: string
}
export function CircleSVG({
  getnumber,
  bgcolor,
  fontColor,
  themeMode,
  size = 20,
  roomWrostColor,
  forType,
  id = "clip0_3001_89021"
}: Props) {
  let circleFill =
    bgcolor == "#871014" || bgcolor == "#000000" ? "white" : "black";
  let textX = "0";
  let textY = "0";
  if (getnumber.length == 1) {
    textX = "10";
    textY = "21";
  } else if (getnumber.length == 2) {
    textX = "5";
    textY = "21";
  } else if (getnumber.length == 3) {
    textX = "2";
    textY = "20";
  }

  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3001_89021)">
        <rect width="36" height="36" rx="12" fill={bgcolor} />
        <g opacity="0.2">
          <circle
            cx="21.9423"
            cy="23.2377"
            r="1.89566"
            transform="rotate(-90 21.9423 23.2377)"
            fill={circleFill}
          />
          <circle
            cx="21.9423"
            cy="8.07266"
            r="1.89566"
            transform="rotate(-90 21.9423 8.07266)"
            fill={circleFill}
          />
          <circle
            cx="2.03793"
            cy="23.2377"
            r="1.89566"
            transform="rotate(-90 2.03793 23.2377)"
            fill={circleFill}
          />
          <circle
            cx="2.03793"
            cy="8.07266"
            r="1.89566"
            transform="rotate(-90 2.03793 8.07266)"
            fill={circleFill}
          />
          <circle
            cx="19.5729"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 19.5729 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="19.5729"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 19.5729 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="-0.331918"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 -0.331918 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="-0.331918"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 -0.331918 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="16.7292"
            cy="26.5554"
            r="2.36957"
            transform="rotate(-90 16.7292 26.5554)"
            fill={circleFill}
          />
          <circle
            cx="16.7293"
            cy="11.3898"
            r="2.36957"
            transform="rotate(-90 16.7293 11.3898)"
            fill={circleFill}
          />
          <circle
            cx="24.3117"
            cy="18.0246"
            r="2.36957"
            transform="rotate(-90 24.3117 18.0246)"
            fill={circleFill}
          />
          <circle
            cx="24.3117"
            cy="2.85946"
            r="2.36957"
            transform="rotate(-90 24.3117 2.85946)"
            fill={circleFill}
          />
          <circle
            cx="4.40735"
            cy="18.0246"
            r="2.36957"
            transform="rotate(-90 4.40735 18.0246)"
            fill={circleFill}
          />
          <circle
            cx="4.40735"
            cy="2.85946"
            r="2.36957"
            transform="rotate(-90 4.40735 2.85946)"
            fill={circleFill}
          />
          <circle
            cx="14.8336"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 14.8336 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="14.8336"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 14.8336 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="10.5682"
            cy="27.0293"
            r="0.94783"
            transform="rotate(-90 10.5682 27.0293)"
            fill={circleFill}
          />
          <circle
            cx="26.6815"
            cy="24.1856"
            r="0.94783"
            transform="rotate(-90 26.6815 24.1856)"
            fill={circleFill}
          />
          <circle
            cx="26.6815"
            cy="9.02049"
            r="0.94783"
            transform="rotate(-90 26.6815 9.02049)"
            fill={circleFill}
          />
          <circle
            cx="6.77718"
            cy="24.1856"
            r="0.94783"
            transform="rotate(-90 6.77718 24.1856)"
            fill={circleFill}
          />
          <circle
            cx="6.77718"
            cy="9.02049"
            r="0.94783"
            transform="rotate(-90 6.77718 9.02049)"
            fill={circleFill}
          />
          <circle
            cx="14.3597"
            cy="23.2378"
            r="0.94783"
            transform="rotate(-90 14.3597 23.2378)"
            fill={circleFill}
          />
          <circle
            cx="14.3597"
            cy="8.07274"
            r="0.94783"
            transform="rotate(-90 14.3597 8.07274)"
            fill={circleFill}
          />
          <circle
            cx="30.4727"
            cy="20.3944"
            r="2.84349"
            transform="rotate(-90 30.4727 20.3944)"
            fill={circleFill}
          />
          <circle
            cx="30.4727"
            cy="5.22933"
            r="2.84349"
            transform="rotate(-90 30.4727 5.22933)"
            fill={circleFill}
          />
          <circle
            cx="9.62051"
            cy="19.4467"
            r="1.89566"
            transform="rotate(-90 9.62051 19.4467)"
            fill={circleFill}
          />
          <circle
            cx="10.5683"
            cy="5.22894"
            r="1.89566"
            transform="rotate(-90 10.5683 5.22894)"
            fill={circleFill}
          />
          <circle
            cx="30.4726"
            cy="27.0293"
            r="1.89566"
            transform="rotate(-90 30.4726 27.0293)"
            fill={circleFill}
          />
          <circle
            cx="30.4726"
            cy="11.8637"
            r="1.89566"
            transform="rotate(-90 30.4726 11.8637)"
            fill={circleFill}
          />
          <circle
            cx="11.0421"
            cy="14.2336"
            r="1.42174"
            transform="rotate(-90 11.0421 14.2336)"
            fill={circleFill}
          />
          <circle
            cx="23.3639"
            cy="28.4509"
            r="1.42174"
            transform="rotate(-90 23.3639 28.4509)"
            fill={circleFill}
          />
          <circle
            cx="23.3639"
            cy="13.2858"
            r="1.42174"
            transform="rotate(-90 23.3639 13.2858)"
            fill={circleFill}
          />
          <circle
            cx="3.45953"
            cy="28.4509"
            r="1.42174"
            transform="rotate(-90 3.45953 28.4509)"
            fill={circleFill}
          />
          <circle
            cx="3.45953"
            cy="13.2858"
            r="1.42174"
            transform="rotate(-90 3.45953 13.2858)"
            fill={circleFill}
          />
          <circle
            cx="17.6769"
            cy="21.8161"
            r="1.42174"
            transform="rotate(-90 17.6769 21.8161)"
            fill={circleFill}
          />
          <circle
            cx="17.6769"
            cy="6.65107"
            r="1.42174"
            transform="rotate(-90 17.6769 6.65107)"
            fill={circleFill}
          />
        </g>
        <text
          fill={circleFill}
          y={textY}
          x={textX}
          style={{
            fontFamily: "Roboto",
            fontWeight: 700,
            fontSize: "14.69",
            textAlign: "center",
            letterSpacing: "0.02em",
            width: "18px",
            height: "21px",
          }}
        >
          {getnumber}
        </text>
        {/* <path d="M11.0467 10.4104V20.8766H8.98075V12.792L6.49871 13.5811V11.9527L10.8243 10.4104H11.0467ZM21.8856 19.2625V20.8766H14.7408V19.4992L18.1195 15.8766C18.4591 15.4988 18.7269 15.1664 18.9229 14.8795C19.119 14.5878 19.2601 14.3271 19.3462 14.0976C19.4371 13.8633 19.4825 13.6409 19.4825 13.4304C19.4825 13.1148 19.4299 12.8446 19.3247 12.6198C19.2195 12.3903 19.064 12.2133 18.8584 12.089C18.6575 11.9647 18.4088 11.9025 18.1123 11.9025C17.7967 11.9025 17.5241 11.979 17.2946 12.132C17.0698 12.2851 16.8976 12.4979 16.7781 12.7705C16.6633 13.0431 16.6059 13.3515 16.6059 13.6959H14.5328C14.5328 13.0742 14.681 12.5051 14.9775 11.9886C15.274 11.4673 15.6925 11.0536 16.2329 10.7476C16.7733 10.4367 17.4141 10.2813 18.1554 10.2813C18.8871 10.2813 19.504 10.4008 20.0062 10.64C20.5131 10.8743 20.8957 11.2138 21.1539 11.6586C21.4169 12.0986 21.5485 12.6246 21.5485 13.2368C21.5485 13.5811 21.4935 13.9182 21.3835 14.2482C21.2735 14.5734 21.1157 14.8986 20.91 15.2238C20.7092 15.5442 20.4653 15.8694 20.1783 16.1994C19.8914 16.5294 19.5733 16.8713 19.2242 17.2252L17.4093 19.2625H21.8856Z" fill="black" /> */}
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="29.3827" height="29.3827" rx="14.6914" fill={"black"} />
        </clipPath>
      </defs>
      {forType && forType === "mapfloor" && (
        <circle
          cx="15"
          cy="15"
          r="14.6914"
          fill="none"
          stroke={getDeviceStrokeColor("", roomWrostColor)}
          strokeWidth="2"
        />
      )}
    </svg>
  );
}

